import { Vue, Prop, Watch, Component } from "vue-property-decorator";
import Vuetify from 'vuetify';
import vuetify from '@/__env/pluggins/vuetify';

import { SignalDispatcher, SimpleEventDispatcher, EventDispatcher } from "strongly-typed-events";
import { UsuarioActual } from '@/views/a-login/login-controlador';
import router from '@/__env/router.index';
import { Utiles } from '@/__env/pluggins/event-bus';
import { Guid } from '@/__env/ext';

export class ControladorDeNotificaciones
{
    public get Socket() { return Utiles.$socket.client; }
    protected SocketIniciado: boolean = false;
    public Iniciar()
    {
        if ( !this.SocketIniciado )
        {
            let self = this;
            this.Socket.on( 'NTWS100', ( x: any ) =>
            {
                self.Agregar( x );
            } );
            this.SocketIniciado = true;
        }
    }

    public Notificaciones: Notificacion[] = [];

    public async Agregar( x: INotificacion )
    {
        let n = new Notificacion();
        await n.Crear( x );
        this.Notificaciones.push( n );
        n.onEliminar.subscribe( ( x ) => { this.Eliminar( x ); } );
        this._onNotificacion.dispatch( n );
    }


    public Eliminar( id: string )
    {
        let idx = this.Notificaciones.findIndex( x => x.Id == id );
        if ( idx > -1 )
        {
            this.Notificaciones.splice( idx, 1 );
        }

    }

    private _onNotificacion = new SimpleEventDispatcher<Notificacion>();
    public get onNotificacion() { return this._onNotificacion.asEvent(); }

}

export class Notificacion
{
    constructor()
    {
        this.Id = Guid.create().toString();
    }

    public readonly Id: string;
    public Tipo: string;
    public Contenido: string;
    public Redirecciona: string;
    public Instancia: Vue;
    public Montada: boolean = false;
    public Eliminada: boolean = false;
    public DivID: string;

    public async Crear( x: INotificacion )
    {
        this.Tipo = x.tipo;
        this.Contenido = x.contenido;
        this.Redirecciona = x.redirecciona;
    }

    Eliminar()
    {
        this.Eliminada = true;
        if ( this.Montada || this.Instancia )
        {
            this.Instancia.$destroy();
            this.Instancia = null;
            this.Montada = false;
            document.getElementById( this.DivID ).remove();
        }

        this._onEliminar.dispatch( this.Id );

    }
    CrearInstancia()
    {
        if ( this.Montada || this.Instancia )
        {
            this.Instancia.$destroy();
            this.Instancia = null;
            this.Montada = false;
        }

        if ( this.Tipo == 'texto' )
        {
            let notif = require( './notificacion-texto.vue' ).default;
            Vue.use( Vuetify );
            let vNotificacion = Vue.extend( notif );
            this.Instancia = new vNotificacion( { propsData: { Notificacion: this }, vuetify: vuetify } );
        }
    }

    private _onEliminar = new SimpleEventDispatcher<string>();
    public get onEliminar() { return this._onEliminar.asEvent(); }
}

export interface INotificacion
{
    tipo: string;
    contenido: string;
    redirecciona: string;
}